import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function Reassurance() {
  return <section className="w-full bg-blueprint px-5 py-12 sm:py-20" data-id="element-196" data-mp="5crwny8ybo3f">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.5
    }} className="mx-auto grid max-w-4xl items-center gap-8 rounded-2xl border border-blue/20 bg-white p-6 sm:p-10 md:grid-cols-2" data-id="element-197" data-mp="jbrcqhieeunz">
        <div className="overflow-hidden rounded-xl" data-id="element-198" data-mp="o9jd7zx3zp3s">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/a1dfd1c1-58c9-4773-abe9-d4f215f9ba3f.jpg" alt="Children's hands testing a popsicle stick catapult on a wooden table" loading="lazy" className="block aspect-[3/2] w-full object-cover" data-id="element-199" data-mp="12z8r8vqavnlh" />
        </div>
        <div className="text-center md:text-left" data-id="element-200" data-mp="171veskfxumcv">
          <h2 className="font-serif-display text-2xl font-bold leading-tight text-navy sm:text-3xl" data-id="element-201" data-mp="16yzhmybx01ph">
            Start with one card today.
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-navy/75 sm:text-base" data-id="element-202" data-mp="2r1kw6jpz0wm">
            After checkout, choose a build, print the card, and turn an ordinary afternoon into
            something your child can proudly say they made.
          </p>
          <div className="mt-7" data-id="element-203" data-mp="gq1abgf23jtu">
            <CTAButton label="GET THE FULL INVENTOR LAB — $27" data-id="element-204" data-mp="gqt54p0txdj2" />
          </div>
        </div>
      </motion.div>
    </section>;
}